<common-scheduled-follow-ups-grid [pageService]="pageService" [data]="followUps()"></common-scheduled-follow-ups-grid>